import TOOLS, { SYM_TOOL_ORDER, TOOL_TYPES, LABEL_MAPPING } from '@/constants/tools'

export const getSymmetryStatisticInfo = (toolKeys = []) => {
  return SYM_TOOL_ORDER.map(item => {
    const key = typeof item === 'string' ? item : item.key
    const count = toolKeys.filter(k => {
      if (item === key) {
        return key === k
      } else {
        return item.sub.includes(k)
      }
    }).length
    return {
      key,
      count,
      label: LABEL_MAPPING[key]
    }
  })
}

/**
 * One area type tool stands for two crystal areas
 * mns: 2 areas
 * ms: 1 area
 * mn: 1 area
 * @param {Array} toolKeys 
 */
export const getAreasCount = (toolKeys = []) => {
  let total = 0
  TOOLS
    .filter(t => t.type === TOOL_TYPES.AREA)
    .forEach(areaTool => {
      total += toolKeys.filter(key => key === areaTool.key).length * areaTool.areaCount
    })
  return total
}


// WEBPACK FOOTER //
// ./src/utils/statistic.js